import { FC } from 'react'
import { BusinessEntityDetails } from '../BusinessEntityDetails'
import { BusinessEntityUsers } from '../BusinessEntityUsers'
import { BusinessEntitySettings } from '../BusinessEntitySettings'

export type componentName = string

export interface ITabList {
  tabLabel: string
  slug: string
  component: FC
}

export const tabList: ITabList[] = [
  {
    tabLabel: 'Details',
    slug: 'details',
    component: BusinessEntityDetails,
  },
  {
    tabLabel: 'Users',
    slug: 'users',
    component: BusinessEntityUsers,
  },
  {
    tabLabel: 'Settings',
    slug: 'settings',
    component: BusinessEntitySettings,
  },
]
